import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExcelService } from 'src/app/services/excel/excel.service';
import { MainService } from 'src/app/services/main/main.service';

@Component({
  selector: 'app-training-export',
  templateUrl: './training-export.component.html',
  styleUrls: ['./training-export.component.scss']
})
export class TrainingExportComponent implements OnInit {
  training_data_list: any;
  exp_list: any[];
  queryparams: any;

  constructor(private mainService: MainService,
    private excelService: ExcelService,
    private routes: ActivatedRoute) { }

  ngOnInit() {
    this.queryparams = this.routes.snapshot.queryParams;
    this.exportReport();
  }


  exportReport() {
    let data = {
      access_token: this.queryparams.ac_tk,
      limit: this.queryparams.limit,
      status: this.queryparams.status,
      time_type: this.queryparams.time_type,
      doctor_id: this.queryparams.doctor_id,
      lang: this.queryparams.lang || ''
    }
    this.mainService.api(data, 'get_doctor_training_schdules', false).subscribe((data) => {
      console.log(data)
      if (data.is_error == 0) {
        if (data.data && data.data.length == 0) {
          document.write('No data found to export');
        }
        this.training_data_list = data.data;
        this.exp_list = [];
        this.exp_list[0] = {
          type_name: 'Training Type',
          schedule_date: ' Date',
          schedule_time: 'Time',
          status: 'Status',
        };
        for (var i = 0; i < this.training_data_list.length; i++) {
          this.exp_list[i + 1] = {};
          this.exp_list[i + 1].type_name = this.training_data_list[i].type_name;
          this.exp_list[i + 1].schedule_date = this.training_data_list[i].start_show_date;
          this.exp_list[i + 1].schedule_time = this.training_data_list[i].start_show_time + ', ' + this.training_data_list[i].training_timezone_short_name;
          this.exp_list[i + 1].status = this.training_data_list[i].training_status_name;
        }

      } else {
        if (data.override_text) {
          document.write(data.override_text);
        }
        if (data.err) {
          document.write(data.err);
        }
      }
    });
  }

  export_fun() {
    this.excelService.exportAsExcelFile(this.exp_list, 'training_list', '.xlsx');
  }

}
